import { Navigate, useParams } from "react-router-dom";
import EmptyState from "@/components/EmptyState";
import ErrorBoundary from "@/components/ErrorBoundary";
import usePageTitle from "@/hooks/usePageTitle";
import { FacilityEmployeesTable } from "@/pages/facilities/[facilityId]/people/employees/_FacilityEmployeesTable";
import { useSectionOperationsAccess } from "./useSectionOperationsAccess";

export default function SectionOperationsEmployeesPage() {
  const { sectionId } = useParams();
  const { ready, sectionOfficeFacilityId, sectionNavError, canViewFacilities, showCommittees } =
    useSectionOperationsAccess(sectionId);

  usePageTitle(`/sections/${sectionId}/operations/employees`, "Sections | Operations | Employees");

  if (!sectionId || !ready) {
    return null;
  }

  if (!canViewFacilities) {
    return (
      <Navigate
        to={showCommittees ? `/sections/${sectionId}/operations/committees` : `/sections/${sectionId}/jobs`}
        replace
      />
    );
  }

  if (sectionNavError) {
    return (
      <div className="w-full" data-testid="section-operations-employees">
        <ErrorBoundary
          variant="inline"
          title="Failed to Load Section Office"
          message="We couldn't load this section's office facility. Please try again or contact tech support."
          className="mt-12"
        />
      </div>
    );
  }

  if (!sectionOfficeFacilityId) {
    return (
      <div className="w-full" data-testid="section-operations-employees">
        <EmptyState
          iconName="badge"
          title="No Section Office Facility"
          caption="Employees for this section are managed on its section office facility. This section does not have one assigned."
        />
      </div>
    );
  }

  return (
    <div className="w-full" data-testid="section-operations-employees">
      <FacilityEmployeesTable facilityId={sectionOfficeFacilityId} />
    </div>
  );
}
